module.exports = __webpack_public_path__ + "bc8f8e84c937de45d0da381fe2825432.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/calia/img/imgRotate.gif
// module id = 1368
// module chunks = 172